function updateNavHeight() {
    const nav = document.querySelector('.navbar');
    if (!nav) return;

    const navHeight = nav.offsetHeight;
    document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);

}

document.addEventListener('DOMContentLoaded', updateNavHeight);
window.addEventListener('resize', updateNavHeight);